export default __webpack_public_path__ + "static/media/screen4.78c3b814.png";